import { RangeGroupVariantType } from '../../../../../components/rangeGroup/types/rangeGroupVariantType';
import { InputCurrencyVariant, InputVariantType, SliderVariantType } from '../variants';
export const getRangeGroupStyles = (FOUNDATIONS, FONT) => {
    return {
        [RangeGroupVariantType.REGULAR]: {
            rootContainer: {
                display: 'flex',
                flex_direction: 'column',
                align_items: 'flex_start',
                gap: FOUNDATIONS.spacing_300,
            },
            inputsContainer: {
                display: 'flex',
                flex_direction: 'row',
                align_items: 'self-start',
                gap: FOUNDATIONS.spacing_250,
            },
            leftInput: {
                variant: InputVariantType.REGULAR,
            },
            rightInput: {
                variant: InputVariantType.REGULAR,
            },
            leftInputCurrency: {
                variant: InputCurrencyVariant.REGULAR,
            },
            rightInputCurrency: {
                variant: InputCurrencyVariant.REGULAR,
            },
            slider: {
                variant: SliderVariantType.RANGE,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map